import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Grid from '@mui/material/Grid';
import {useStylesECDS} from './ecdsStyle';
import config from '../../../../app/config';
import AgyleTextField from '../../../../components/ui/fields/agyleTextField';
import {cleanObject} from '../../../../util/patientContextUtil';

const GpRegistration = (props) => {
    const {t} = useTranslation();
    const classes = useStylesECDS();

    const {isSmall} = props;

    // General Medical Dataset
    const [gp, setGp] = useState({
        GeneralMedicalPractitioner_Specified: '',
        GeneralPractice_PatientRegistration: '',
    });

    // For ReadOnly Data
    const disableData = useRef({});

    // Validation
    const validationEnabled = config?.modules?.forms?.ecds?.validation || false;
    const [error, setError] = useState({
        practiceCode: false,
        practitioner: false,
    });

    // Initial Data
    useEffect(async () => {
        let data = {};
        let dataToBlock = {};

        if (props.patient?.studies?.EmergencyCare?.GPRegistration) {
            data = {...props.patient?.studies?.EmergencyCare?.GPRegistration};
        }

        if (props.patient.patient?.gp?.href) {
            const gp = props.patient.patient?.gp?.href?.replace('/gp/', '');
            dataToBlock = {
                ...dataToBlock,
                GeneralMedicalPractitioner_Specified: gp,
            };
        }

        if (props.patient.patient?.surgery?.href) {
            const surgery = props.patient.patient?.surgery?.href?.replace('/surgeries/', '');
            dataToBlock = {
                ...dataToBlock,
                GeneralPractice_PatientRegistration: surgery,
            };
        }

        data = {
            ...data,
            ...dataToBlock,
        };

        setGp((prevState) => ({...prevState, ...data}));
        disableData.current = {...cleanObject(dataToBlock)};

    }, []);

    const updateData = () => {
        const data = {
            GeneralMedicalPractitioner_Specified: gp.GeneralMedicalPractitioner_Specified,
            GeneralPractice_PatientRegistration: gp.GeneralPractice_PatientRegistration,
        };
        props.setData(data);
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (validate()) {
                updateData();
            }
        }, 400);

        return () => clearTimeout(timeoutId);
    }, [gp]);

    const changeHandler = (event) => {
        setGp((prevState) => ({...prevState, [event.target.name]: event.target.value}));
    };

    const validate = () => {
        let check = true;

        if (validationEnabled) {
            const errorData = {
                practiceCode: gp.GeneralPractice_PatientRegistration !== '' ? !props.checkLenght(6, 6, gp.GeneralPractice_PatientRegistration) : false,
                practitioner: gp.GeneralMedicalPractitioner_Specified !== '' ? !props.checkLenght(8, 8, gp.GeneralMedicalPractitioner_Specified) : false,
            };
            setError(prevState => ({...prevState, ...errorData}));

            for (let prop in errorData) {
                if (errorData[prop]) {
                    check = false;
                    break;
                }
            }

            if (props.valid) {
                const validObj = {
                    name: 'General Medical Registration',
                    groupStatus: 'R',
                    mandatory: false,
                    errors: !check,
                    pickers: false,
                };
                props.valid(prevState => ({...prevState, 'gp': validObj}));
            }
        }
        return check;
    };

    if (props.accordion !== 'General Medical Registration') return null;

    return (
        <div className={classes.root}>
            <Grid container spacing={2} style={{marginTop: 1}}>
                <Grid item xs={isSmall ? 12 : 6}>
                    <AgyleTextField
                        name="GeneralMedicalPractitioner_Specified"
                        label={t('General Medical Practitioner')}
                        onChange={changeHandler}
                        value={gp.GeneralMedicalPractitioner_Specified || ''}
                        error={error.practitioner}
                        helperText={error.practitioner ? 'Input must be 8 characters long.' : ''}
                        maxLength={8}
                        minLength={8}
                        readOnly={!!disableData?.current.GeneralMedicalPractitioner_Specified}
                        fullWidth
                        debounce
                        noBorder={false}
                        withNewBackground
                        size="large"
                    />
                </Grid>

                <Grid item xs={isSmall ? 12 : 6}>
                    <AgyleTextField
                        name="GeneralPractice_PatientRegistration"
                        label={t('General Practice Code')}
                        onChange={changeHandler}
                        value={gp.GeneralPractice_PatientRegistration || ''}
                        error={error.practiceCode}
                        helperText={error.practiceCode ? 'Input must be 6 characters long.' : ''}
                        maxLength={6}
                        minLength={6}
                        readOnly={!!disableData?.current.GeneralPractice_PatientRegistration}
                        fullWidth
                        debounce
                        noBorder={false}
                        withNewBackground
                        size="large"
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default GpRegistration;
